import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import { Box } from '@material-ui/core';
import useStyles from './status.styled';
import CheckIcon from '@material-ui/icons/Check';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const Status = ({ status }) => {
  const classes = useStyles();

  return (
    <Box className={clsx(classes[status])}>
      {status === 'COMPLETED' ? (
        <CheckIcon className={classes.completedIcon} />
      ) : (
        <FiberManualRecordIcon className={classes.circleIcon} />
      )}
    </Box>
  );
};

Status.propTypes = {
  status: PropTypes.oneOf([
    'OPEN',
    'APPROVED',
    'CANCELLED',
    'COMPLETED',
    'INPROGRESS',
    'PENDING_APPROVAL',
    'CLOSED',
    'NONE',
    'FAIL',
    'PREAUTH',
    'DISPUTED',
    'COMPLETE',
    'REFUNDED',
    'PREAUTHREFUNDED',
  ]).isRequired,
};

export default Status;
